export default __webpack_public_path__ + "static/media/Stabby_Loop.e2860003.gif";